import moment from 'moment'
import { v4 as uuidv4 } from 'uuid'
import {
  AgencyDetailsModel,
  LicenceDetails,
  LicenceDetailsState,
  UpdateAgencyDetails,
  UpdateAgencyDetailsAccountType,
} from '@urbanx/agx.agencies.client'
import { CompanyLicenseDetails } from './types'

export const stripCompanyLicenceUuid = (
  licence: CompanyLicenseDetails
): LicenceDetails => {
  const { uuid, ...persistedLicence } = licence

  void uuid

  return persistedLicence
}

export const withCompanyLicenceUuids = (
  licences: LicenceDetails[]
): CompanyLicenseDetails[] =>
  licences.map((licence) => ({
    ...licence,
    uuid: uuidv4(),
  }))

export const getNextAvailableState = (
  companyLicences: CompanyLicenseDetails[]
): LicenceDetailsState | undefined => {
  const allStates = Object.values(LicenceDetailsState)

  return allStates.find(
    (state) => !companyLicences.map((licence) => licence.state).includes(state)
  )
}

export const createCompanyLicence = (
  state: LicenceDetailsState | undefined
): CompanyLicenseDetails => ({
  licenceNumber: '',
  uuid: uuidv4(),
  state,
  expiryDate: new Date(moment().format('YYYY-MM-DDTHH:mm:ss')),
})

export const sanitizeAgencyDetails = (
  agencyInformation: AgencyDetailsModel,
  companyLicences: CompanyLicenseDetails[]
): UpdateAgencyDetails => {
  const payload: UpdateAgencyDetails = {
    ...agencyInformation,
    accountType:
      agencyInformation.accountType as unknown as UpdateAgencyDetailsAccountType,
    companyDetails: {
      ...agencyInformation.companyDetails,
      licences: companyLicences.map(stripCompanyLicenceUuid),
    },
  }

  return payload
}

export const getLicenceStateOptions = (
  licence: CompanyLicenseDetails,
  companyLicences: CompanyLicenseDetails[],
  agencyStateOptions: Array<{ value: string; label: string }>
) =>
  agencyStateOptions.filter(
    (option) =>
      option.value === licence.state ||
      !companyLicences.some(
        (companyLicence) =>
          companyLicence.uuid !== licence.uuid &&
          companyLicence.state?.toString() === option.value
      )
  )
